module.exports = __webpack_public_path__ + "static/media/bookmark-fill.97c74079.svg";